import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from 'react-router';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import { GuestRoute } from '@/components/layouts/guest-route';
import { ProtectedRoute } from '@/components/layouts/protected-route';
import { AuthLayout } from '@/components/layouts/auth-layout';
import { AppShell } from '@/components/layouts/app-shell';
import LoginPage from '@/routes/login';
import AccountsPage from '@/routes/accounts';
import AccountDetailPage from '@/routes/account-detail';
import FeedbacksPage from '@/routes/feedbacks';
import AnalyticsPage from '@/routes/analytics';
import NotFoundPage from '@/routes/not-found';

const router = createBrowserRouter([
  {
    element: <GuestRoute />,
    children: [
      {
        path: '/login',
        element: <AuthLayout />,
        children: [{ index: true, element: <LoginPage /> }]
      }
    ]
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <Navigate to='/accounts' replace /> },
          { path: 'accounts', element: <AccountsPage /> },
          { path: 'accounts/:accountId', element: <AccountDetailPage /> },
          { path: 'feedbacks', element: <FeedbacksPage /> },
          { path: 'analytics', element: <AnalyticsPage /> }
        ]
      }
    ]
  },
  { path: '*', element: <NotFoundPage /> }
]);

export function App() {
  return (
    <TooltipProvider delayDuration={200}>
      <RouterProvider router={router} />
      <Toaster position='top-center' richColors />
    </TooltipProvider>
  );
}
